import logoSrc from '../assets/brand/tenerfit-logo.png';
import { brand } from '../config/brand';

interface LogoProps {
  height?: number;
  className?: string;
}

/**
 * Brand mark. Wraps the raster logo with an accessible name and sensible
 * defaults for sharp rendering on high-DPI displays.
 *
 * TODO: replace with an SVG export from the source design file for lossless
 * scaling. See `frontend/src/assets/brand/README.md`.
 */
export function Logo({ height = 56, className }: LogoProps) {
  return (
    <img
      src={logoSrc}
      alt={brand.name}
      height={height}
      className={className}
      style={{ height, width: 'auto' }}
      decoding="async"
      // React 18 expects the lowercase attribute name
      {...{ fetchpriority: 'high' }}
    />
  );
}
